<template>
    <div class="marketplace-community-section">
        <v-container>
            <div class="text-center mb-8">
                <h2 class="section-title">สะดวกทุกการช้อป กับสินค้าชุมชนคุณภาพเยี่ยม</h2>
                <p class="section-subtitle">จากแหล่งผลิตทั่วไทย</p>
            </div>

            <!-- Loading skeleton -->
            <v-row v-if="loading">
                <v-col v-for="n in 4" :key="n" cols="6" sm="3">
                    <v-skeleton-loader type="image, article" />
                </v-col>
            </v-row>

            <!-- Error state -->
            <div v-else-if="error" class="text-center py-8">
                <p class="grey--text">ไม่สามารถโหลดสินค้าได้ กรุณาลองใหม่อีกครั้ง</p>
            </div>

            <!-- Product cards -->
            <v-row v-else>
                <v-col v-for="(item, index) in items" :key="item.id || index" cols="6" sm="3" md="3">
                    <ProductCardCommunity :product="item" :showShop="true">
                        <template #action>
                            <v-btn block color="#00A862" class="white--text mt-2" elevation="0" small
                                :to="{ name: 'product_detail', params: { id: item.id } }" hover>
                                ดูสินค้า
                            </v-btn>
                        </template>
                    </ProductCardCommunity>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import { getCommunityProductsApi } from "@/services/api/product";
import ProductCardCommunity from "@/components/Shared/ProductCardCommunity.vue";

export default {
    name: "MarketplaceCommunity",
    components: {
        ProductCardCommunity
    },
    data() {
        return {
            items: [],
            loading: false,
            error: false,
        };
    },
    async created() {
        await this.fetchCommunityProducts();
    },
    methods: {
        async fetchCommunityProducts() {
            this.loading = true;
            this.error = false;
            try {
                const res = await getCommunityProductsApi(8);
                this.items = res.data || [];
            } catch (e) {
                console.error("MarketplaceCommunity fetch error:", e);
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.marketplace-community-section {
    padding: 60px 0;
    max-width: 1440px;
    margin: 0 auto;
}

.section-title {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
}

.section-subtitle {
    font-size: 18px;
    color: #666;
}

@media (max-width: 768px) {
    .marketplace-community-section {
        padding: 32px 0;
    }
    .section-title {
        font-size: 20px;
    }
    .section-subtitle {
        font-size: 14px;
    }
}
</style>
